// extracted by mini-css-extract-plugin
module.exports = {"container":"_99551c8aa8--container--_jteP","partial-checkbox-wrapper":"_99551c8aa8--partial-checkbox-wrapper--AgytH","label":"_99551c8aa8--label--HGR_0"};